<template>
  <div class="account-page scrollable">
    <div class="page-header">
      <h1>Indexing pages in Google</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>Indexing Pages</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="top-bar">
      <div class="count-user">
        <p>Total Pages Count: 112253</p>
      </div>
    </div>

    <el-form inline>
      <el-form-item>
        <el-input v-model="inputURL" placeholder="Inspect any URL in &quot;https://ifindcheaters.com/&quot;" :style="{ 'width': '400px' }"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button v-if="isAdmin" type="info" @click="">
          <i class="mdi mdi-magnify"></i> Inspect URL
        </el-button>
      </el-form-item>
    </el-form>

    <div class="top-bar">

      <div class="accounts-filter">
        Show
        <el-select
            v-model="countTinderAccounts"
            @change="changeCount"
            placeholder=" "
            style="width:70px"
        >
          <el-option
              v-for="item in countTinderAccountsOptions"
              :key="item.value"
              :label="item.value"
              :value="item.value"
          >
          </el-option>
        </el-select>
        entries
      </div>

      <div class="header-buttons">
        <el-button v-if="isAdmin"
                    type="primary"
                    :disabled="!isAnyRowSelected()"
                    @click=""
        >Inspect URLs
        </el-button>          
        <el-button v-if="isAdmin"
                    type="primary"
                    :disabled="!isAnyRowSelected()"
                    @click=""
        >Request Indexing All
        </el-button>        
      </div>      
    </div> 

    <el-table ref="indexingTable" :data="indexingPagesGroup" style="width: 100%;" @sort-change="sort" @filter-change="filterChange" :row-class-name="rowClassName">
      <el-table-column prop="checkbox" :width="50">
        <template slot="header" slot-scope="scope">
          <span class="no-wrap-cell">#</span>
        </template>
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.checkbox"></el-checkbox>
        </template>
      </el-table-column>

      <el-table-column prop="created_at" sort-key="created_at" :min-width="130">
        <template slot="header" slot-scope="scope">
          <div :style="{ textAlign: 'center' }">
            <span>URL</span>
          </div>
        </template>
        <template slot-scope="scope">
          <div>{{ scope.row.url }}</div>
        </template>
      </el-table-column>

      <el-table-column prop="status" sort-key="status" label="Status" :filters="statusOptions"  column-key="statusColumn" :min-width="100" :align="'center'">
        <template slot-scope="scope">
          <div :style="{ textAlign: 'center' }">
            <span class="el-tag el-tag--success"><i class="mdi mdi-alert-circle"></i> {{ scope.row.status }}</span>            
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="created_at" label="Last update" sortable sort-key="created_at" :min-width="100">
        <!-- <template slot="header" slot-scope="scope">
          <div :style="{ textAlign: 'center' }">
            <span>Last update</span>
          </div>
        </template> -->
        <template slot-scope="scope">
          <div>{{ scope.row.last_update }}</div>
        </template>
      </el-table-column>

      <!-- actions -->
      <el-table-column label="Actions" width="260px">
        <template slot-scope="scope">
          <el-button v-if="isAdmin"
                     size="mini"
                     type="warning"
                     :disabled="isAnyRowSelected()"
                     @click=""
          ><i class="mdi mdi-search-web"></i> Request indexing
          </el-button>
          <el-button v-if="isAdmin"
                     size="mini"
                     type="danger"
                     :disabled="isAnyRowSelected()"
                     @click=""
          ><i class="mdi mdi-sync"></i> Update
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagin-wrp">
      <el-pagination
          :background="true"
          layout="prev, pager, next"
          :page-size="indexingPagesGroup.length"
          :total="indexingPagesGroup.length"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
// import HeaderSortTitle from '../../components/UsersList/HeaderSortTitle'
import axios from 'axios'

export default {
  name: 'IndexingPages',
  components: {
    
  },
  data () {
    return {
      filterBlock:{},
      inputURL: '',
      sortBy: {
        autoscan: 0,
        status: 0,
        account_group_id: 0,
        created_at: 0,
      },
      filterTinderAccounts: '',
      countTinderAccounts: 50,
      countTinderAccountsOptions: [
        {value: 5},
        {value: 10},
        {value: 25},
        {value: 50},
        {value: 100},
      ],
      vnc_server: `${process.env.VUE_APP_VNC_SERVER}`,
      usersCount: 0,
      showByStatus: 0,
      isSubmitedAuthorize: false,
      isIndexClicked: null,
      statusOptions: [
        {
          value: 'blocked',
          label: 'blocked',
          text: 'Blocked'

        },
        {
          value: 'active',
          label: 'active',
          text: 'Active'
        },
        {
          value: 'verification',
          label: 'verification',
          text: 'Verification'
        }
      ],
      showByAccountGroup: 0,

      selectedRows: [],
      indexingPagesGroup: [
        {
          checkbox: false,
          url: 'https://ifindcheaters.com/blog/post/can-you-search-someone-on-tinder-3-ways-to-view-tinder-profiles-online',
          status: 'Not started',
          last_update: 'Jan 3, 2024'
        },
        {
          checkbox: false,
          url: 'https://ifindcheaters.com/blog/post/ways-to-view-tinder-profiles-online',
          status: 'Not started',
          last_update: 'Dec 31, 2023'
        },
        {
          checkbox: false,
          url: 'https://ifindcheaters.com/blog/post/can-you-search-someone-on-tinder-3-ways-to-view-tind',
          status: 'Not started',
          last_update: 'Feb 06, 2021'
        },
        {
          checkbox: false,
          url: 'https://ifindcheaters.com/blog/post/can-you-search-someone-on-tinder-3-ways-to-view-tinder-profiles-online',
          status: 'Not started',
          last_update: 'Nov 03, 2023'
        },
        {
          checkbox: false,
          url: 'https://ifindcheaters.com/blog/post/can-you-search-someone-on-tinder-3-ways-to-view-tinder-profiles-online',
          status: 'Not started',
          last_update: 'Nov 03, 2023'
        },
        {
          checkbox: false,
          url: 'https://ifindcheaters.com/blog/post/can-you-search-someone-on-tinder-3-ways-to-view-tinder-profiles-online',
          status: 'Not started',
          last_update: 'Nov 03, 2023'
        },
        {
          checkbox: false,
          url: 'https://ifindcheaters.com/blog/post/can-you-search-someone-on-tinder-3-ways-to-view-tinder-profiles-online',
          status: 'Not started',
          last_update: 'Nov 03, 2023'
        },
        {
          checkbox: false,
          url: 'https://ifindcheaters.com/blog/post/can-you-search-someone-on-tinder-3-ways-to-view-tinder-profiles-online',
          status: 'Not started',
          last_update: 'Nov 03, 2023'
        },
        {
          checkbox: false,
          url: 'https://ifindcheaters.com/blog/post/can-you-search-someone-on-tinder-3-ways-to-view-tinder-profiles-online',
          status: 'Not started',
          last_update: 'Nov 03, 2023'
        },        

      ],
      chosenPage: 1,
    }
  },
  computed: {
    ...mapGetters({
      user: 'userData',
      tinderAccounts: 'tinderAccounts/getTinderAccounts',
      tinderAccountsMeta: 'tinderAccounts/getTinderAccountsMeta',
      paidProxies: 'tinderAccounts/getPaidProxies',
      phoneProviders: 'tinderAccounts/getPhoneProviders',
      tinderAccountGroups: 'tinderAccounts/getTinderAccountGroups'
    }),

    isAdmin() {
      return this.user? this.user.is_admin:false;
    },

   

  },
  mounted () {
    this.$store.dispatch('tinderAccounts/getTinderAccounts')
    this.$store.dispatch('tinderAccounts/getTinderAccountGroups')
    axios
        .get(`${process.env.VUE_APP_TINDERSTORE_URL}/api/user/total`)
        .then((response) => {
          this.usersCount = response.data.total;
        })
        .catch(error => console.log(error));
  },
  methods: {
    isAnyRowSelected() {
      return this.indexingPagesGroup.some(row => row.checkbox);
    },     
    rowClassName({ row }) {
      return row.checkbox ? 'selected-row' : '';
    },    
    choosePage (e) {
      this.chosenPage = e
      this.updateList()
    },
    filterChange(filter) {
      Object.assign(this.filterBlock, filter)
      this.updateList()
    },
    sort(by) {
      let key  = (typeof by ==="object") ? by.prop : by

      if (this.sortBy[key] === 0) {
        this.sortBy[key] = 1
      } else if (this.sortBy[key] === 1) {
        this.sortBy[key] = -1
      } else if (this.sortBy[key] === -1) {
        this.sortBy[key] = 0
      }
      if(typeof by ==="object" && by.order==null){
        this.sortBy[key] = 0
      }
      this.updateList()
    },
    getFilters() {
      let params = 'sort='
      if (this.sortBy) {
        for (let itm in this.sortBy) {
          if (this.sortBy[itm] === 1) {
            params = `${params}${itm},`
          } else if (this.sortBy[itm] === -1) {
            params = `${params}-${itm},`
          }
        }
      }
      if (params === 'sort=') {
        params = ''
      }
      params = `${params}&page=${this.chosenPage}`
      if (this.countTinderAccounts) {
        params = `${params}&per_page=${this.countTinderAccounts}`
      }

      if (this.showByAccountGroup != 0) {
        params = `${params}&group=${this.showByAccountGroup}`
      }

      if (this.showByStatus != 0) {
        let status = this.statusOptions[this.showByStatus].label.toLowerCase();
        params = `${params}&status=${status}`
      }

      if (this.showByAutoscan != 3) {
        params = `${params}&autoscan=${this.showByAutoscan}`
      }

      if (this.filterTinderAccounts.length) {
        params = `${params}&filter=${this.filterTinderAccounts}`
      }

      if (Object.keys(this.filterBlock).length) {
        Object.entries(this.filterBlock).forEach(([key, value]) => {
          if(value.length === 0){
            return;
          }
          params = `${params}&${key}=`+JSON.stringify(value)
        });
      }

      return params;
    },
    changeCount (e) {
      this.countTinderAccounts = e
      this.updateList()
    },
    changeByAccountGroup(e) {
      this.showByAccountGroup = e
      this.updateList()
    },
    changeByStatus(e) {
      this.showByStatus = e
      this.updateList()
    },
    changeByAutoscan(e) {
      this.showByAutoscan = e
      this.updateList()
    },
    searchTinderAccounts (e) {
      this.filterTinderAccounts = e
      this.updateList()
    },
    updateList() {
      let params = this.getFilters();
      this.$store.dispatch('tinderAccounts/getTinderAccounts', params)
    },
    goToAddTinderAccount(){
      this.$router.push({name: 'tinder-account-create'})
    },
    handleEdit (index, row) {
      this.$router.push({name: 'tinder-account-edit', params: {id: row.id}})
    },
    handleDelete (data) {
      this.$store.dispatch('tinderAccounts/deleteTinderAccount', data.id)
    },
    handleAuthorize (index, row) {
      this.isSubmitedAuthorize = true
      this.isIndexClicked = index
      this.$store.dispatch('tinderAccounts/authorizeTinderAccount', row.id)
          .then(response => {
            this.$notify.success({ title: 'Phone number #'+row.phone,  message: 'has beed success authorized.' })
          })
          .catch(error => {
            this.$notify.error({ title: 'Phone number #'+row.phone,  message: 'authorization error' })
          })
          .finally(() => {
            this.isSubmitedAuthorize = false
            this.isIndexClicked = null
            this.updateList()
          })
    }
  }
}
</script>

<style scoped lang="scss">

.account-page {
  overflow-x: hidden;
}
th {
  .cell {
    .pointer {
      cursor: pointer;
    }
  }
}

.accounts-filter {
  width: 200px;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > div {
    margin: 0 5px;
  }
}
.selected-row {
  background-color: red !important;
}
</style>
<style lang="scss">
.selected-row {
  background-color: #d8e2e942 !important;
}
</style>
